"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBFriendlyNegative = function SvgBFriendlyNegative(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M71.88 123.742a81.487 81.487 0 01-34.068-7.369 2.109 2.109 0 111.77-3.828 77.156 77.156 0 0032.313 6.982c18.13 0 35.164-6.034 47.962-16.999 12.799-10.965 19.668-25.288 19.668-40.657a49.972 49.972 0 00-5-21.776 2.107 2.107 0 013.8-1.82 54.13 54.13 0 015.415 23.61c0 16.591-7.516 32.165-21.171 43.86-13.656 11.696-31.554 17.997-50.688 17.997z"
  }), (0, _core.jsx)("path", {
    d: "M25.372 141.956a4.328 4.328 0 01-4.215-5.156l5.255-27.43a50.906 50.906 0 01-6.983-5.205C6.898 92.652 0 77.634 0 61.87c0-16.585 7.516-32.165 21.172-43.86C34.827 6.315 52.739 0 71.88 0c22.92 0 44.668 9.532 58.162 25.506a2.107 2.107 0 11-3.218 2.718C114.118 13.192 93.58 4.214 71.881 4.214c-18.137 0-35.172 6.035-47.998 17C11.056 32.179 4.215 46.537 4.215 61.87c0 14.568 6.413 28.49 18.06 39.189a46.867 46.867 0 007.515 5.402 2.107 2.107 0 011.047 2.24l-5.55 28.899a.091.091 0 00.043.112c.037.03.09.03.126 0l22-11.33a2.107 2.107 0 011.932 3.744L27.395 141.47a4.26 4.26 0 01-2.023.485z"
  }), (0, _core.jsx)("path", {
    d: "M58.626 53.954a2.107 2.107 0 01-2.108-2.107v-3.33a2.107 2.107 0 114.215 0v3.33a2.107 2.107 0 01-2.107 2.107zM85.157 53.954a2.107 2.107 0 01-2.108-2.107v-3.33a2.107 2.107 0 114.215 0v3.33a2.107 2.107 0 01-2.107 2.107zM71.895 83.885c-14 0-26.834-8.106-33.493-21.143a2.107 2.107 0 113.744-1.918c5.936 11.626 17.337 18.847 29.742 18.847 12.405 0 23.798-7.221 29.734-18.847a2.107 2.107 0 113.744 1.918C98.72 75.779 85.887 83.885 71.895 83.885z"
  })));
};

var _default = SvgBFriendlyNegative;
exports["default"] = _default;